/**
 * Account roles (PRD section 3). A user holds one or more; every account is a player.
 * `moderator`, `reviewer` and `super_admin` are MOGZO staff roles.
 */
export const USER_ROLES = ['player', 'developer', 'moderator', 'reviewer', 'super_admin'] as const;

export type UserRole = (typeof USER_ROLES)[number];

export const STAFF_ROLES = ['moderator', 'reviewer', 'super_admin'] as const satisfies UserRole[];

/** Roles that must have two-factor authentication turned on before they can act. */
export const TWO_FACTOR_REQUIRED_ROLES = [
  'developer',
  ...STAFF_ROLES,
] as const satisfies UserRole[];
